import React, { Component } from 'react';

class Header extends Component {
  render() {
    return (
      <nav className="navbar is-white">
        <div className="navbar-brand">
          <a className="navbar-item brand-text" href="/">
            Sean Arthur
          </a>
          <button className="button navbar-burger">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        
        <div className="navbar-menu">
          <div className="navbar-start">
            <a className="navbar-item" href="/">
              Home
            </a>
            <a className="navbar-item" href="/">
              About
            </a>
          </div>

          <div className="navbar-end">
            
          </div>
        </div>
        
      </nav>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/layouts/Header.jsx